export const LIMITED_PAYLOAD_SIZE = 1024 * 1024; //1MB
export const CHUNK_PAYLOAD_SIZE = 0.5 * 1024 * 1024; //500KB
